import React from 'react';
import { SvgCircleIcon, IconComponent, IconGlyphComponent } from '@shapeable/icons';

export const EnergyIcon: IconComponent = (props) => (
  <SvgCircleIcon { ...props } glyphWidth={96} glyphHeight={96}>

  </SvgCircleIcon>
);

export const EnergyIconGlyph: IconGlyphComponent = (props) => <EnergyIcon { ...props } variant='glyph' />;